import { contactConstants } from '../../constant';

const initialState = {
  contactsData: null,
  contactData: null,
};

export const fetch_user_contacts_reducer = (state = initialState, action) => {
  switch (action.type) {
    case contactConstants.FETCH_USER_CONTACT_ACTION_REQUEST:
      return {
        type: 'alert-success',
        message: action.payload,
      };
    case contactConstants.FETCH_USER_CONTACT_ACTION_SUCCESS:
      return {
        contactsData: action.payload,
      };
    case contactConstants.FETCH_USER_CONTACT_ACTION_FAILURE:
      return {
        type: 'alert-failure',
        error: action.payload,
      };
    

    default:
      return state;
  }
};

export const fetch_user_contact_details_reducer = (state = initialState, action) => {
  switch (action.type) {
    case contactConstants.FETCH_USER_CONTACT_DETAILS_ACTION_REQUEST:
      return {
        type: 'alert-success',
        message: action.payload,
      };
    case contactConstants.FETCH_USER_CONTACT_DETAILS_ACTION_SUCCESS:
    case contactConstants.UPDATE_USER_CONTACT_ACTION_SUCCESS:
      return {
        contactData: action.payload,
      };
    case contactConstants.FETCH_USER_CONTACT_DETAILS_ACTION_FAILURE:
      return {
        type: 'alert-failure',
        error: action.payload,
      };
    default:
      return state;
  }
};
